import { handleCommonErrors } from 'utils/api'
import { useQueryApi } from 'utils/api'

import type { TTopicList } from 'types/microlearning'
import type { CommonListResponse } from 'types/api'

type FilterTopic =
  | 'recommendation'
  | 'newest'
  | 'oldest'
  | 'almost-done'
  | 'just-started'
  | 'title'

type Params = {
  sort: FilterTopic
}

export function useAPITopicList(params: Params) {
  return useQueryApi<CommonListResponse<TTopicList>>(
    `/microlearnings/topic/v1/list?sort=${params.sort}`,
    {
      queryConfig: {
        enabled: !!params.sort,
      },
      errorHandlerFn: (status, path, error) => {
        handleCommonErrors(status ?? 500, path, error)
      },
    }
  )
}
